/* NH1: native Shopify product form, progressive enhancement, no mock checkout. */
(() => {
  function init(root) {
    if (root.dataset.nh1Initialized) return;
    root.dataset.nh1Initialized = 'true';
    const data = JSON.parse(root.querySelector('[data-nh1-data]').textContent);
    const select = root.querySelector('select[name="id"]');
    const form = root.querySelector('form');
    const qty = root.querySelector('[name="quantity"]');
    const hero = root.querySelector('#nh1-main-image');
    const sticky = root.querySelector('.sticky-buy');
    const note = root.querySelector('#nh1-variant-note');
    const feedback = root.querySelector('.nh1-feedback');
    const variant = () => data.variants.find(v => String(v.id) === select.value);
    function message(v) {
      const t = v.title.toLowerCase();
      if (/pack|bundle/.test(t)) return 'Bundle selected. Includes the lens options shown in the variant name.';
      if (t.includes('gray') || t.includes('grey')) return 'Gray polarized — for daytime reflected glare.';
      if (t.includes('black')) return 'Black photochromic — responds to outdoor UV. In-car darkening is not guaranteed.';
      if (t.includes('yellow')) return 'Yellow tint — does not amplify light or promise improved night vision.';
      return 'Frame and lens details vary by option.';
    }
    function update(changeURL = true) {
      const v = variant(); if (!v) return;
      root.querySelectorAll('[data-nh1-price]').forEach(el => el.textContent = v.price);
      const compare = root.querySelector('[data-nh1-compare]');
      compare.textContent = v.compare; compare.hidden = !v.compare;
      root.querySelectorAll('[data-nh1-submit]').forEach(btn => {
        btn.disabled = !v.available;
        btn.textContent = v.available ? 'Add to cart ↗' : 'Sold out';
      });
      root.querySelectorAll('[data-nh1-variant]').forEach(btn => btn.setAttribute('aria-pressed', String(btn.dataset.nh1Variant === String(v.id))));
      hero.src = v.image; hero.alt = v.title + ' — SunRay NH1';
      root.querySelector('#nh1-sticky-image').src = v.image;
      root.querySelector('#nh1-sticky-label').textContent = v.title;
      root.querySelector('#nh1-gallery-tag').textContent = v.title;
      root.querySelector('#nh1-gallery-caption').textContent = 'Selected option · Images illustrate styling';
      root.querySelectorAll('.thumb').forEach(btn => btn.setAttribute('aria-pressed', 'false'));
      note.textContent = 'Selected: ' + v.title + '. ' + message(v) + (v.available ? '' : ' Currently sold out.');
      qty.min = v.min; qty.step = v.step;
      if (v.max !== null && v.max !== undefined) qty.max = v.max; else qty.removeAttribute('max');
      qty.value = v.min;
      feedback.hidden = true;
      if (changeURL) {
        const url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url);
      }
    }
    select.addEventListener('change', () => update());
    root.querySelectorAll('[data-nh1-variant]').forEach(btn => btn.addEventListener('click', () => {select.value = btn.dataset.nh1Variant; update();}));
    root.querySelectorAll('[data-select]').forEach(btn => btn.addEventListener('click', () => {
      const v = data.variants.find(v => v.title.toLowerCase().includes(btn.dataset.select) && !/pack|bundle/i.test(v.title));
      if (v) {select.value = String(v.id); update();}
      root.querySelector('#nh1-buy').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      const target = v && root.querySelector('[data-nh1-variant="' + v.id + '"]'); if (target) target.focus({preventScroll:true});
    }));
    root.querySelectorAll('[data-nh1-quantity]').forEach(btn => btn.addEventListener('click', () => {
      const v = variant(); const next = Number(qty.value) + Number(btn.dataset.nh1Quantity) * v.step;
      qty.value = Math.max(v.min, v.max == null ? next : Math.min(v.max, next));
      qty.dispatchEvent(new Event('change', {bubbles:true}));
    }));
    root.querySelectorAll('.thumb').forEach(btn => btn.addEventListener('click', () => {
      hero.src = btn.dataset.image; hero.alt = btn.dataset.alt;
      root.querySelector('#nh1-gallery-tag').textContent = 'NH1 / PRODUCT & LIFESTYLE';
      root.querySelector('#nh1-gallery-caption').textContent = btn.dataset.alt;
      root.querySelectorAll('.thumb').forEach(b => b.setAttribute('aria-pressed', String(b === btn)));
    }));
    form.addEventListener('submit', e => {
      const v = variant();
      if (!v || !v.available) {e.preventDefault(); feedback.hidden=false; feedback.textContent='This option is sold out. Please choose another option.';}
      // Available variants submit through Shopify's native /cart/add form.
    });
    let queued = false;
    const refreshSticky = () => {
      queued = false;
      sticky.classList.toggle('visible', form.getBoundingClientRect().bottom < 0 && root.getBoundingClientRect().bottom > 80);
    };
    const onScroll = () => {if (!queued) {queued = true; requestAnimationFrame(refreshSticky);}};
    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);
    root.nh1Cleanup = () => {window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onScroll);};
    refreshSticky();
    update(false); root.classList.add('nh1-ready');
  }
  const all = () => document.querySelectorAll('[data-nh1-root]').forEach(init);
  if (!window.nh1ProductLoaded) {
    window.nh1ProductLoaded = true;
    document.addEventListener('shopify:section:load', all);
    document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-nh1-root]').forEach(r => r.nh1Cleanup && r.nh1Cleanup()));
  }
  all();
})();